import { Col, Container, Row } from "react-bootstrap"
import { UserSearchForm } from "../../Components/Forms/UserSearchForm/UserSearchForm"
import { convertActiveQueryToUrl } from "../../Helpers/Query/queryHelpers"
import useActiveQueryHook from "../../Hooks/UseActiveQuery/useActiveQueryHook"
import { navigateTo } from "../../redux/router/routerActions"
import { useAppDispatch } from "../../redux/store"
import './usersPage.scss'
import { useGetUsersQuery } from "../../services/bClientApi"
import MongoPagination from "../../Components/Pagination/MongoPagination"
import UserEntry from "../../Components/Users/UserEntry"

export default function UsersPage() {

  const dispatch = useAppDispatch()

  const { activeQuery } = useActiveQueryHook({ 
    limit: 15,
    page: 1,
  })

  const {
    data,
    error,
    isLoading,
  } = useGetUsersQuery({
    usersQuery: {
      ...activeQuery.query,
    },
    pagination: {
      page: activeQuery.page,
      limit: activeQuery.limit,
    }
  })
  const userList = data?.docs || []

  const loadPage = (pageParams: { query: any, page: number, limit: number }) => {
    const destination = `/users?${convertActiveQueryToUrl(pageParams)}`
    dispatch(navigateTo(destination))
  }

  return (
    <Container>
      <Row>
        <Col>
          <h1>Users Page</h1>
          <hr />
          {error && (<>{JSON.stringify(error)}<br /></>)}

          <UserSearchForm
            disabled={isLoading}
            onSubmit={(values: any) => {
              loadPage({
                query: values,
                page: 1,
                limit: activeQuery.limit
              })
            }}
            firstName={activeQuery.query.firstName}
            lastName={activeQuery.query.lastName}
            email={activeQuery.query.email}
            role={activeQuery.query.role}
          />
          <hr />

          {userList && userList.length > 0 && (
            <div className="user-list-container">
              <Row>
                {userList.map((user: any, _idx: number) => (
                  <Col key={user._id} xs={12} md={6} lg={4} className="mb-3">
                    <UserEntry
                      _id={user._id}
                      firstName={user.firstName}
                      lastName={user.lastName}
                      email={user.email}
                      lastLogin={user.lastLogin}
                      profilePic={user.profilePic}
                      role={user.role}
                    />
                  </Col>
                ))}
              </Row>
            </div>
          )}

            <MongoPagination
              data={data}
              loadPage={(pageLoadInfo: { page: number, limit?: number }) => {
                loadPage({
                  query: activeQuery.query,
                  limit: activeQuery.limit,
                  ...pageLoadInfo
                })
              }}
            />
        </Col>
      </Row>
    </Container>
  )
}


